import { useApolloClient, useLazyQuery, useQuery } from "@apollo/client";
import { GET_BULK_PRICE_DATA, GET_BULK_PRICE_EDIT_PRODUCTS_BY_LINK, GET_BULK_PRICE_EDIT_PRODUCTS_BY_MANUFACTURER } from "../../Queries/bulkPriceEdit";
import { useState } from "react";
import { GetApolloErrorText } from "../../../../GlobalFunctions/helper";
import { UseNotification } from "../../../Notification/Library/UseNotification";
import { useTranslation } from "react-i18next";

const UseGetBulkPriceData = (CallBack) => {
    const client = useApolloClient();
    const { t } = useTranslation();

    const [content, SetContent] = useState([]);
    const [productLoading, setProductLoading] = useState(false);

    const { AddNotification } = UseNotification();
    const { loading, error, data } = useQuery(GET_BULK_PRICE_DATA, {
        fetchPolicy: "network-only",
        onCompleted: (d) => {},
    });

    const loadCategoryProducts = async (linkID) => {
        try {
            setProductLoading(true);
            var products = await client.query({
                query: GET_BULK_PRICE_EDIT_PRODUCTS_BY_LINK,
                variables: {
                    lang: "cz",
                    linkID: linkID,
                },
                fetchPolicy: "network-only",
            });
            const contentData = GetContentData(products.data.AllProducts);
            SetContent(contentData);
            setProductLoading(false);
        } catch (error) {
            setProductLoading(false);
            AddNotification(GetApolloErrorText(error), false);
        }
    };
    const loadManufacturersProducts = async (manufacturerID) => {
        try {
            setProductLoading(true);
            var products = await client.query({
                query: GET_BULK_PRICE_EDIT_PRODUCTS_BY_MANUFACTURER,
                variables: {
                    lang: "cz",
                    filters: {
                        manufacturerID: manufacturerID,
                    },
                },
                fetchPolicy: "network-only",
            });
            const contentData = GetContentData(products.data.AllProducts);
            SetContent(contentData);
            setProductLoading(false);
        } catch (error) {
            setProductLoading(false);
            AddNotification(GetApolloErrorText(error), false);
        }
    };

    const SelectAll = (e) => {
        SetContent((prev) =>
            prev.map((item) => ({
                ...item,
                selected: e.target.checked,
                subData: item.subData?.map((subItem) => ({
                    ...subItem,
                    selected: e.target.checked,
                })),
            }))
        );
    };
    const SelectRow = (e, productID) => {
        const isProduct = productID.startsWith("p-");
        //produkt
        if (isProduct) {
            SetContent((prev) =>
                prev.map((item) =>
                    item.rowID == productID
                        ? {
                              ...item,
                              selected: e.target.checked,
                              subData: item.subData
                                  ? item.subData.map((subItem) => ({
                                        ...subItem,
                                        selected: e.target.checked,
                                    }))
                                  : item.subData,
                          }
                        : item
                )
            );
            //varianta
        } else {
            SetContent((prev) =>
                prev.map((item) => ({
                    ...item,
                    subData: item.subData
                        ? item.subData.map((subItem) => (subItem.rowID == productID ? { ...subItem, selected: e.target.checked } : subItem))
                        : item.subData,
                }))
            );
        }
    };

    const GeneratePriceAfterDiscount = (product) => {
        if (product.isDiscountPercentage) return product.price - Math.round((product.price / 100) * product.discount);
        else return product.price - product.discount;
    };
    const GetContentData = (data, parentProductData = null) => {
        var contentData = [];

        for (let val of data) {
            //pokud jde o hlavní produkt
            if (val.productID) {
                var cData = {
                    data: [
                        {
                            value: val.name,
                            className: "flex-1 no-padding-right",
                        },
                        {
                            value: "",
                            className: "flex-1 text-center",
                        },
                        {
                            value: val.price,
                            className: "flex-1 text-center",
                        },
                        {
                            value: GeneratePriceAfterDiscount(val),
                            className: "flex-1 text-center",
                        },
                    ],
                };
                //pokud jde o variantu produktu
            } else {
                var cData = {
                    data: [
                        {
                            value: val.name ? val.name : parentProductData?.name,
                            className: "flex-1 no-padding-right",
                        },
                        {
                            value: val.productCode,
                            className: "flex-1 text-center",
                        },
                        {
                            value: val.price,
                            className: "flex-1 text-center",
                        },
                        {
                            value: GeneratePriceAfterDiscount(val),
                            className: "flex-1 text-center",
                        },
                    ],
                };
            }

            cData.rowID = `${val.productID ? `p-${val.productID}` : `pv-${val.productVariantID}`}`;
            cData.selected = false;

            if (val.variants) cData.subData = GetContentData(val.variants, val);

            contentData.push(cData);
        }
        return contentData;
    };
    const productListHeaderData = [
        {
            value: t("ProductName"),
            className: "flex-1",
        },
        {
            value: t("ProductCode"),
            className: "flex-1 text-center",
        },
        {
            value: t("PriceWithVAT"),
            className: "flex-1 text-center",
        },
        {
            value: t("PriceWithVatAfterDiscount"),
            className: "flex-1 text-center",
        },
    ];

    return {
        loading,
        error,
        data,
        content,
        productLoading,
        productListHeaderData,
        loadCategoryProducts,
        SelectAll,
        SelectRow,
        loadManufacturersProducts,
        SetContent,
    };
};

export default UseGetBulkPriceData;
